import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { BestQuater, PublicationImpactFactor, PublicationInfluence } from '@/module/Journal';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Article, ArticleRequest } from './ArticleTypes';

export function getArticleImpactFactor(articleId: Id) {
  return axios.get<PublicationImpactFactor>(`/author/articles/${articleId}/impact-metrics`, {}).then(getData);
}

export function getArticleInfluence(articleId: Id) {
  return axios.get<PublicationInfluence>(`/author/articles/${articleId}/influence-metrics`, {}).then(getData);
}

export function getArticleBestQ(articleId: Id, bestOf: number) {
  return axios.get<BestQuater>(`/author/articles/${articleId}/best-q`, { params: { bestOf: bestOf } }).then(getData);
}

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Article>>('/author/articles/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Article>(`/author/articles/${id}`).then(getData);
}

export function edit(id: Id, request: ArticleRequest) {
  return axios.put<Article>(`/author/articles/${id}`, request).then(getData);
}

export function create(request: ArticleRequest) {
  return axios.post<Article>(`/author/articles`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/articles/${id}`).then(getData);
}

export function addNewAlias(articleId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/articles/${articleId}/add-new-alias`, request).then(getData);
}
